module.exports = __webpack_public_path__ + "static/img/youku.457ff815.jpg";